import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemIcon, ListItemText, Switch } from '@mui/material';

import { subscribe, unsubscribe } from 'app/store/notifications/pushSubscriptionSlice';
import { Icon, useSettings, useSpeechToText } from 'app/main/components';
import { askPushUserConsent, getPushUserConsent } from 'app/main/components/PushNotificationsUtils';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

export default function UsersDetailsSectionPermissions({ isEdit }: { isEdit: boolean }) {
	const dispatch = useDispatch<any>();
	const { t } = useSettings();

	const { pushSubscription } = useSelector<any, any>(state => state.notifications);
	const pushUserConsent = getPushUserConsent();

	const changePushConsent = async () => {
		if (pushSubscription === null) askPushUserConsent().then(() => dispatch(subscribe()));
		else dispatch(unsubscribe());
	};

	const { isSpeechToTextSupported, onUserAskPermissions, userConsent: speechToTextConsent } = useSpeechToText();

	const changeSpeechToTextConsent = () => onUserAskPermissions();

	// const [mailNotification, setMailNotification] = React.useState(userMailNotificationEnabled || false);

	// const changeMailNotificationConsent = () => {
	// 	executeStored({
	// 		action: 'st_users_update',
	// 		data: {
	// 			user_uid: user.user_uid,
	// 			user_user_modified_uid: user.user_uid,
	// 			user_mail_notification_enabled: !mailNotification ? 1 : 0
	// 		},
	// 		successHandler: () => {
	// 			dispatch(alertSuccessMsg(t));
	// 			setMailNotification(!mailNotification);
	// 		}
	// 	});
	// };

	return (
		<DetailsSectionWrapper title={t('USERS_PERMISSIONS_SECTION')} subheader={t('USERS_PERMISSIONS_SUBHEADER')}>
			<List dense disablePadding>
				<ListItem disablePadding>
					<ListItemIcon className="min-w-40">
						<Icon icon="notifications" />
					</ListItemIcon>
					<ListItemText
						primary={t('PUSH_NOTIFICATIONS_SETTING')}
						secondary={!pushUserConsent && <i>{t('NOT_SUPPORTED')}</i>}
					/>
					<Switch
						edge="end"
						checked={pushSubscription !== null}
						disabled={!pushUserConsent || !isEdit}
						onChange={changePushConsent}
					/>
				</ListItem>
				<ListItem disablePadding>
					<ListItemIcon className="min-w-40">
						<Icon icon="text-to-speech" />
					</ListItemIcon>
					<ListItemText
						primary={t('SPEECH_TO_TEXT_SETTING')}
						secondary={!isSpeechToTextSupported && <i>{t('NOT_SUPPORTED')}</i>}
					/>
					<Switch
						edge="end"
						checked={speechToTextConsent === 'granted'}
						disabled={!isSpeechToTextSupported || !isEdit}
						onChange={changeSpeechToTextConsent}
					/>
				</ListItem>
				{/* <ListItem disablePadding>
					<ListItemIcon className="min-w-40">
						<Icon icon="email-alert-outline" />
					</ListItemIcon>
					<ListItemText primary={t('MAIL_NOTIFICATION_SETTING')} />
					<Switch edge="end" onChange={changeMailNotificationConsent} checked={mailNotification} />
				</ListItem> */}
			</List>
		</DetailsSectionWrapper>
	);
}
